import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_PROJECT = "GET_LIST_PROJECT";
export const UPDATE_ACTIVE = "UPDATE_ACTIVE";
export const GET_DETAIL_PROJECT = "GET_DETAIL_PROJECT";
export const SEARCH_PROJECT = "SEARCH_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const SAVE_PROJECT = "SAVE_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const SET_LIST_PROJECT = "SET_LIST_PROJECT";
export const SET_DETAIL_PROJECT = "SET_DETAIL_PROJECT";
export const SET_SEARCH_PROJECT = "SET_SEARCH_PROJECT";




const state = {
    project: [],
    projectDetail: [],
    results:[],

};

const getters = {
    project(state) {
        return state.project;
    },
    projectDetail(state) {
        return state.projectDetail;
    },
    results(state) {
        return state.results;
    },


};

const actions = {
    [GET_LIST_PROJECT](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_PROJECT}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_PROJECT, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_PROJECT](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_PROJECT}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_PROJECT, data);
                }
                resolve(data);
            });
        });
    },
    [SEARCH_PROJECT](context,payload) {
        return new Promise(resolve => {
            ApiService.query(`${API.SEARCH_PROJECT}`,payload).then(({data}) => {
                if (data.status) {
                    context.commit(SET_SEARCH_PROJECT, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_PROJECT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_PROJECT}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_PROJECT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_PROJECT}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_ACTIVE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_ACTIVE}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_PROJECT](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_PROJECT}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_PROJECT](state, data) {
        state.project = data.data;
    },
    [SET_DETAIL_PROJECT](state, data) {
        state.projectDetail = data.data;
    },
    [SET_SEARCH_PROJECT](state, data) {
        state.results = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};